import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
const { color, layout } = primitives;

// Hide on mobile utility
export const HideOnMobile = styled.span`
  display: inline-block;
  @media (max-width: ${layout.breakpoint3}px) {
    display: none;
  }
`;

export const GalleryContainer = styled.div`
  text-align: center;
`;

export const MainImageWrapper = styled.div`
  overflow: hidden;
`;

export const MainImage = styled.img`
  height: auto;
  width: 100%;
  @media (min-width: 750px) {
    height: 256px;
    width: auto;
  }
`;

export const ThumbnailsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35px;
  gap: 10px;
  overflow-x: auto;
`;

export const ThumbnailsWrapper = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  @media (max-width: ${layout.breakpoint2}px) {
    gap: 4px;
  }
`;

interface ThumbnailProps {
  active?: boolean;
}

export const Thumbnail = styled.img<ThumbnailProps>`
  width: 64px;
  height: 64px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 6px;
  border: 3px solid
    ${(props) => (props.active ? color.electricBlue7 : 'transparent')};
  transition: border 0.3s ease;
  &:hover {
    border-color: ${color.electricBlue7};
  }
`;

export const Button = styled.button`
  padding: 8px 16px;
  font-size: 40px;
  font-weight: 500;
  cursor: pointer;
  background-color: ${color.gray0};
  color: ${color.black};
  border: none;
`;
export const MobileIndicatorWrapper = styled.span`
  display: inline-block;
  cursor: pointer;
  gap: 4px;
`;

export const ImageWrapper = styled.div`
  width: 24px;
  height: 24px;
  > img {
    width: 8px;
    height: 8px;
  }
`;

export const MobileStepperWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;

  @media (min-width: ${layout.breakpoint3}px) {
    display: none;
  }
`;
